import React from "react"
import { Window, Text, View } from "react-ame-components"

export class WindowExample extends React.Component {
  render() {
    return (
      <Window>
        <View>
          <Text>Esse é o window</Text>
        </View>
      </Window>
    )
  }
}
